import Dropdown from '../../js/components/dropdown';
import * as helpers from '../../js/helpers';

/**
 *
 * @author Sereja Smerechevskiy - OSI
 *
 * Data options:
 *
 * data-show-count - show count of selected categories in field
 * data-prefix - manage field prefix if data-show-count - on
 * data-suffix - manage field suffix if data-show-count - on
 * data-placeholder - manage field placeholder (if you don't check any category and default state)
 * data-relations - (required field) - set relation between multiselect and hidden input field, shoud be equal to hidden field id
 *
 */

const getCheckboxes = element => [].slice.call(element.parentElement.querySelectorAll(`input[type="checkbox"]:not([id=${element.id}])`));

const getCategoriesValue = (multiselect) => {
    const checkedItems = [].slice.call(multiselect.querySelectorAll('input[type="checkbox"]:checked'));
    return checkedItems.map(checkbox => checkbox.value).join(',');
};

const getCategoriesNames = (multiselect) => {
    const checkedItems = [].slice.call(multiselect.querySelectorAll('input[type="checkbox"]:checked + label'));
    const placeholder = multiselect.getAttribute('data-placeholder') || 'Toutes les categories';
    const prefix = multiselect.getAttribute('data-prefix') || 'selected';
    const suffix = multiselect.getAttribute('data-suffix') || 'categories';
    const showCount = multiselect.getAttribute('data-show-count') || true;
    let string = placeholder;

    if (checkedItems.length) {
        if (showCount && checkedItems.length === 1) {
            string = checkedItems[0].innerHTML;
        } else if (showCount && checkedItems.length > 1) {
            string = `${prefix} ${checkedItems.length} ${suffix}`;
        } else {
            string = checkedItems.map(label => label.innerHTML).join(', ');
        }
    }

    return string;
};

const getParentCategories = (checkbox) => {
    const categoriesArray = [];
    let parentCategory = checkbox.parentElement.parentElement;

    while (!helpers.hasClass(parentCategory, 'checkbox')) {
        categoriesArray.push(parentCategory.querySelector('input[type="checkbox"]'));
        parentCategory = parentCategory.parentElement;
    }

    return categoriesArray;
};

const getState = (checkbox) => {
    const items = getCheckboxes(checkbox);
    const itemsCount = items.length;

    let checkedItems = 0;
    let state = 'unchecked';

    if (itemsCount > 0) {
        items.forEach((item) => {
            checkedItems = item.checked ? checkedItems + 1 : checkedItems;
        });

        if (checkedItems === itemsCount) {
            state = 'checked';
        } else if (checkedItems > 0 && checkedItems < itemsCount) {
            state = 'indeterminate';
        }
    } else {
        if (checkbox.checked) {
            state = 'checked';
        }
    }

    return state;
};

const hasSubcategory = checkbox => getCheckboxes(checkbox).length > 0;

const setAttributesByState = (checkbox, state) => {
    switch (state) {
    case 'checked':
        checkbox.checked = true;
        checkbox.indeterminate = false;
        checkbox.setAttribute('aria-checked', true);
        break;
    case 'indeterminate':
        checkbox.checked = false;
        checkbox.indeterminate = true;
        checkbox.setAttribute('aria-checked', 'mixed');
        break;
    default:
        checkbox.indeterminate = false;
        checkbox.checked = false;
        checkbox.setAttribute('aria-checked', false);
        break;
    }
};

const manageCategoryBranch = (checkbox) => {
    const parents = getParentCategories(checkbox);
    const children = hasSubcategory(checkbox) ? getCheckboxes(checkbox) : null;

    checkbox.setAttribute('aria-checked', checkbox.checked);

    if (children !== null) {
        children.forEach((item) => {
            item.checked = checkbox.checked;
        });
    }

    if (parents.length) {
        parents.forEach((parent) => {
            setAttributesByState(parent, getState(parent));
        });
    }
};

const handleMultiselectControls = (multiselect) => {
    const multiselectToggle = multiselect.querySelector('.multiselect__toggle');

    // Relation field
    const dataId = multiselect.getAttribute('data-relations');
    const multiselectInput = document.getElementById(dataId);

    if (dataId === undefined) {
        console.error('data-relations attribute missed, please add it');
        return;
    }

    if (multiselectInput === null) {
        console.error('relation input missed, please add it');
        return;
    }

    multiselectInput.value = getCategoriesValue(multiselect);
    multiselectToggle.innerHTML = getCategoriesNames(multiselect);
};

function handleMultiselectCategories(checkboxes, multiselect) {
    const checkboxesArray = [].slice.call(checkboxes);
    const checkedArray = checkboxesArray.filter(checkbox => checkbox.checked);

    handleMultiselectControls(multiselect);

    checkedArray.forEach(checkbox => manageCategoryBranch(checkbox));

    checkboxesArray.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
            manageCategoryBranch(checkbox);
            handleMultiselectControls(multiselect);
        });
    });
}

function handleMultiselect() {
    const multiselect = document.querySelectorAll('.multiselect');

    if (multiselect !== null) {
        for (let i = 0; i < multiselect.length; i++) {
            const multiselectEl = multiselect[i];
            const checkboxes = multiselectEl.querySelectorAll('input[type="checkbox"]');

            handleMultiselectCategories(checkboxes, multiselectEl);
        }
    }
}

export default function initMultiselect() {
    // Multiselect
    const multiselect = document.querySelectorAll('.multiselect');

    if (multiselect !== null) {
        const multiselectObj = new Dropdown('.multiselect:not(.-group)', {
            wrapperClass: 'multiselect',
            dropdownClass: 'multiselect__dropdown',
            btnClass: 'multiselect__toggle',
            onInit: handleMultiselect,
        });

        const multiselectGroup = new Dropdown('.multiselect.-group', {
            wrapperClass: 'multiselect',
            dropdownClass: 'multiselect__dropdown',
            btnClass: 'multiselect__toggle',
            closeOnOutsideClick: false,
            focusTrap: false,
            onInit: handleMultiselect,
        });
    }
}
